// extracted by mini-css-extract-plugin
export var header1 = "heading_elements-module--header1--667b4";
export var header1_frame_star = "heading_elements-module--header1_frame_star--3607a";
export var header1_text = "heading_elements-module--header1_text--5af56";
export var header2 = "heading_elements-module--header2--55a60";
export var header2_text = "heading_elements-module--header2_text--8033d";